<script>
  import CreateView from '../base/CreateView.vue'
  import FormInput from '../form/form-input.vue'
  import FormSelect from '../form/form-select.vue'

  export default {
    components: {
      CreateView,
      FormInput,
      FormSelect
    },
    computed: {
      companies () {
        const companies = this.$store.getters['authentication/companies']
        return companies.map((company) => {
          return {
            value: company['@id'],
            text: company.name,
          }
        })
      }
    },
  }
</script>
<template>
  <create-view store="user" update-route="UserUpdate" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="name" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="username" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="email" type="email" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="plainPassword" type="password" class="col-3"></form-input>
    <form-select :store="slotProps.store" prop-name="companies" :multiple="true" :options="companies" class="col-3"></form-select>
  </create-view>
</template>

